import { DatePicker } from '@mui/x-date-pickers-pro';
import { CalendarToday } from '@vedmarket/ui-kit';
import {useFormContext} from "react-hook-form";
import {INVOICE_FORM, InvoiceForm} from "../../editInvoice";
import {useTranslation} from "react-i18next";
import moment, { Moment } from 'moment'
import 'moment/locale/ru';
import {useState} from "react";
import {isDemoPage} from "../../../../../../../../../../../../utils/hooks";
import {useDemoInvoiceDate} from 'components/cabinet/demo/steps/packaging/use-invoice';

const DateInput  = () => {

  const { t } = useTranslation()

  const { register, getValues, setValue } = useFormContext<InvoiceForm>()

  const isDemoMode = isDemoPage()

  const initialDate = getValues()[INVOICE_FORM.INVOICE_DATE]

  const [ date, setDate ] = useState<Moment | null>(isDemoMode ? null : moment(initialDate || ''));

  const [ error, setError ] = useState(false);

  const demoPlayback = useDemoInvoiceDate({ initialDate, setDate, setValue })

  const handleValidateDatePicker = async (value: Moment | null) => {
    const formattedDate = moment(value).format('YYYY-MM-DD');
    setDate(value);
    value && setValue(INVOICE_FORM.INVOICE_DATE, formattedDate)
    setError(formattedDate === 'Invalid date' ? true: Boolean(moment().diff(moment(value)) < 0))
  }

  return (
    <DatePicker
      label={t('calc__text__main__dateOfInvoice')}
      {...register(INVOICE_FORM.INVOICE_DATE, { required: true })}
      value={date}
      {...demoPlayback}
      disableFuture
      onChange={(value) => handleValidateDatePicker(value)}
      slots={{ openPickerIcon: CalendarToday }}
      slotProps={{
        popper: {
          placement: 'bottom-start',
          modifiers: [
            { name: 'offset', options: { offset: [ 0, 8 ] } },
            { name: 'preventOverflow', options: { altAxis: true, tether: false, padding: 8 } },
            { name: 'flip', options: { fallbackPlacements: [ 'bottom-start', 'top-start' ], padding: 8 } },
          ],
        },
        textField: {
          className: 'invoice-form__invoice_date',
          error,
          helperText: error ? t('errors__message__incorrectDate') : '',
          InputLabelProps: { shrink: true },
        },
      }}
    />
  )
}

export default DateInput
